var _rect, _mask, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.167,
    y: 41.6666,
    width: 5.83333,
    height: 1.66667,
    rx: 0.833333,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2173 25.0506C32.121 25.0506 32.028 25.0237 31.9416 24.9663C31.7124 24.8111 31.6493 24.4974 31.8021 24.2646C32.6226 23.013 33.0544 21.5557 33.0544 20.0477C33.0544 15.8511 29.706 12.4405 25.5868 12.4405C21.4677 12.4405 18.1225 15.8511 18.1225 20.0477C18.1225 21.4747 18.5112 22.8646 19.252 24.069C19.3981 24.3051 19.3251 24.6188 19.0925 24.7673C18.86 24.9157 18.5511 24.8415 18.4049 24.6053C17.5678 23.2424 17.126 21.6636 17.126 20.0477C17.126 15.2945 20.9229 11.4285 25.5902 11.4285C30.2574 11.4285 34.0543 15.2945 34.0543 20.0477C34.0543 21.7581 33.5627 23.4111 32.6359 24.828C32.5396 24.9697 32.3801 25.0506 32.2173 25.0506Z",
    fill: "#151F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5636 36.0111C25.3875 36.0111 25.2281 35.92 25.1384 35.7682L18.0661 23.9947C17.9232 23.7552 17.9963 23.4448 18.2322 23.2998C18.468 23.1547 18.7736 23.2289 18.9165 23.4684L25.5669 34.5402L31.7622 24.3692C31.9084 24.1296 32.214 24.0588 32.4466 24.2039C32.6791 24.3489 32.7522 24.6627 32.6093 24.8988L25.9888 35.7716C25.8991 35.92 25.7363 36.0111 25.5636 36.0111Z",
    fill: "#151F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7788 19.2279L27.2375 19.1705C27.1246 19.1705 27.0349 19.0795 27.0349 18.9648V16.3773C27.0349 16.2626 26.9452 16.1715 26.8323 16.1715H24.6066C24.4936 16.1715 24.4039 16.2626 24.4039 16.3773V18.9648C24.4039 19.0795 24.3143 19.1705 24.2013 19.1705H21.6401C21.5272 19.1705 21.4375 19.2616 21.4375 19.3763V21.5995C21.4375 21.7142 21.5272 21.8052 21.6401 21.8052H24.2013C24.3143 21.8052 24.4039 21.8963 24.4039 22.011V24.6896C24.4039 24.8043 24.4936 24.8954 24.6066 24.8954H26.8323C26.9452 24.8954 27.0349 24.8043 27.0349 24.6896V22.0211C27.0349 21.9064 27.1246 21.8154 27.2375 21.8154L29.7788 21.8727C29.8917 21.8727 29.9814 21.7816 29.9814 21.6669V19.4337C29.9847 19.319 29.8917 19.2279 29.7788 19.2279Z",
    fill: "#3188CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5561 38.0452H17.6243C17.3485 38.0452 17.126 37.8192 17.126 37.5392C17.126 37.2592 17.3485 37.0332 17.6243 37.0332H33.5527C33.8284 37.0332 34.051 37.2592 34.051 37.5392C34.051 37.8192 33.8284 38.0452 33.5561 38.0452Z",
    fill: "#151F24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28,
    fill: "white",
    transform: "translate(10 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicIcon);
export default __webpack_public_path__ + "static/media/clinicIcon.62102c5c6fcccf51621e1dc74ba890e0.svg";
export { ForwardRef as ReactComponent };